import { FieldType } from '../../../types/Field.type';
export const BillingEmail = {
    priority: 10,
    label: 'fields.payload.billing.billing_email.label',
    fallbackLabel: 'Billing email',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: FieldType.String,
    mfValidation: {
        pathToValidation: 'base/email',
    },
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    var _a, _b;
    return (((_b = (_a = payload.contract_onboarding_type) === null || _a === void 0 ? void 0 : _a.valueOf) === null || _b === void 0 ? void 0 : _b.call(_a)) === 'UPSELL_WEBSTORE_TO_ADS_MANAGER');
}
function isApplicable(payload, path) {
    var _a, _b;
    return (((_b = (_a = payload.contract_onboarding_type) === null || _a === void 0 ? void 0 : _a.valueOf) === null || _b === void 0 ? void 0 : _b.call(_a)) === 'UPSELL_WEBSTORE_TO_ADS_MANAGER');
}
